"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Query_1 = __importDefault(require("utils/Query"));
const CompareView_1 = __importDefault(require("../components/CompareView"));
const CubeCompareNavbar_1 = __importDefault(require("../components/cube/CubeCompareNavbar"));
const DynamicFlash_1 = __importDefault(require("../components/DynamicFlash"));
const ErrorBoundary_1 = __importDefault(require("../components/ErrorBoundary"));
const RenderToRoot_1 = __importDefault(require("../components/RenderToRoot"));
const ChangesContext_1 = require("../contexts/ChangesContext");
const CubeContext_1 = require("../contexts/CubeContext");
const DisplayContext_1 = require("../contexts/DisplayContext");
const FilterContext_1 = __importStar(require("../contexts/FilterContext"));
const MainLayout_1 = __importDefault(require("../layouts/MainLayout"));
const CubeComparePageInner = ({ cards, cube, cubeB, onlyA, onlyB, both }) => {
    const [openCollapse, setOpenCollapse] = (0, react_1.useState)(Query_1.default.get('f') ? 'filter' : null);
    const { cardFilter } = (0, react_1.useContext)(FilterContext_1.default);
    const filteredCards = cardFilter ? cards.filter(cardFilter.filter) : cards;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CubeCompareNavbar_1.default, { cubeA: cube, cubeAID: cube.id, cubeB: cubeB, cubeBID: cubeB.id, openCollapse: openCollapse, setOpenCollapse: setOpenCollapse }),
        react_1.default.createElement(DynamicFlash_1.default, null),
        react_1.default.createElement(ErrorBoundary_1.default, null,
            react_1.default.createElement(CompareView_1.default, { cards: filteredCards, onlyA: onlyA, onlyB: onlyB, both: both }))));
};
const CubeComparePage = ({ cards, cube, cubeB, loginCallback = '/', onlyA, onlyB, both, }) => {
    return (react_1.default.createElement(FilterContext_1.FilterContextProvider, null,
        react_1.default.createElement(MainLayout_1.default, { loginCallback: loginCallback },
            react_1.default.createElement(DisplayContext_1.DisplayContextProvider, { cubeID: cube.id },
                react_1.default.createElement(ChangesContext_1.ChangesContextProvider, { cube: cube },
                    react_1.default.createElement(CubeContext_1.CubeContextProvider, { initialCube: cube, cards: { mainboard: cards, maybeboard: [] } },
                        react_1.default.createElement(CubeComparePageInner, { cards: cards, cube: cube, cubeB: cubeB, onlyA: onlyA, onlyB: onlyB, both: both })))))));
};
exports.default = (0, RenderToRoot_1.default)(CubeComparePage);
